import { ApiResponse } from 'apisauce';
import api from '../utils/api/api.service';
import { ErrorInfo } from '../../interfaces/error-info.interface';
import { ResponseModel } from '../../interfaces/response-model.interface';
import errorHelper from '../utils/api/error-helper.service';
import {
  OpsAgentPerformanceModel,
  OpsFilterModel,
  OpsLostAnalysisModel,
  OpsPendingPipelineModel,
  OpsSlaAttemptsModel,
  OpsSummaryModel,
  OpsVerticalFunnelModel
} from '../../models/lead-ops.model';

const MODULE_NAME = 'LeadOpsModule';

const fail = (response: unknown, report: string): ErrorInfo => {
  const res = response as { status?: number; data?: { errorCode?: string }; problem?: unknown };
  return errorHelper(
    Number(res.status),
    res.data && res.data.errorCode ? String(res.data.errorCode || '') : String(res.problem || ''),
    MODULE_NAME,
    report
  );
};

/**
 * One call per section, not one call for the whole dashboard.
 *
 * Each section then loads, fails and retries on its own — a slow or broken
 * aggregation shows an error in its own card instead of blanking the page, and
 * the sections that did load stay readable. Nine sections behind one request
 * would make the dashboard only as available as its worst query.
 */
function report<T>(name: string, filter: OpsFilterModel): Promise<T | ErrorInfo> {
  return api
    .opsReport<T>(name, filter)
    .then((response: ApiResponse<ResponseModel<T>, ErrorInfo>) => {
      if (response.ok && response.data && response.data.data) return response.data.data;
      return fail(response, name);
    });
}

export const getOpsSummary = (filter: OpsFilterModel) => report<OpsSummaryModel>('summary', filter);

export const getOpsAgentPerformance = (filter: OpsFilterModel) =>
  report<OpsAgentPerformanceModel>('agent-performance', filter);

export const getOpsPendingPipeline = (filter: OpsFilterModel) =>
  report<OpsPendingPipelineModel>('pending-pipeline', filter);

export const getOpsLostAnalysis = (filter: OpsFilterModel) =>
  report<OpsLostAnalysisModel>('lost-analysis', filter);

export const getOpsVerticalFunnel = (filter: OpsFilterModel) =>
  report<OpsVerticalFunnelModel>('vertical-funnel', filter);

export const getOpsSlaAttempts = (filter: OpsFilterModel) =>
  report<OpsSlaAttemptsModel>('sla-attempts', filter);
